import StructuredDataForm from './StructuredDataForm'

export default StructuredDataForm
